export const GET_ALL_CHALLENGES_REQUEST = 'ChallengeListPage/GET_ALL_CHALLENGES_REQUEST';
export const GET_ALL_CHALLENGES_SUCCESS = 'ChallengeListPage/GET_ALL_CHALLENGES_SUCCESS';
export const GET_ALL_CHALLENGES_FAILURE = 'ChallengeListPage/GET_ALL_CHALLENGES_FAILURE';
export const GET_ME_REQUEST = 'ChallengeListPage/GET_ME_REQUEST';
export const GET_ME_SUCCESS = 'ChallengeListPage/GET_ME_SUCCESS';
export const GET_ME_FAILURE = 'ChallengeListPage/GET_ME_FAILURE';
export const SET_FILTERS = 'ChallengeListPage/SET_FILTERS';
